import { render, staticRenderFns } from "./Fanzone.vue?vue&type=template&id=74ddedc6&"
import script from "./Fanzone.vue?vue&type=script&lang=js&"
export * from "./Fanzone.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports